import { render, staticRenderFns } from "./EditScoreType.vue?vue&type=template&id=65c6fd32&"
import script from "./EditScoreType.vue?vue&type=script&lang=ts&"
export * from "./EditScoreType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports